import { QUERY_KEY } from 'constants/globalConstants'
import DashboardApiService from 'apiService/dashboardApiService'
import { useQuery } from 'react-query'

const useNodeMttrMtbfDetails = (id, nodeId) => {
    return useQuery(QUERY_KEY.NODE_MTTR_MTBF_DETAILS, () => DashboardApiService.getNodeMttrMtbf(id, nodeId), {retry: false})
}

export default useNodeMttrMtbfDetails